import values from "../values";

import { Layout } from "../components";
import { NotFound } from "../screen";
import { Navigate, Route, Routes } from "react-router-dom";

import ServiceContainer from "../screen/ServiceScreen/Container/Company.Container";
import SchoolContainer from "../screen/SchoolScreen/Container";
import DriverContainer from "../screen/DriverScreen/Container/Company.container";
import DashboardContainer from "../screen/DashboardScreen/container";
import ParentContainer from "../screen/ParentScreen/Container/Company.container";
import AbsentContainer from "../screen/AbsentScreen/Container";
import HistoryContainer from "../screen/LogScreen/Container";
import FinanCialScreen from "../screen/FinancialScreen";
import CompanyOtherContainer from "../screen/CompanyOtherScreen";
import TicketContainer from "../screen/TicketScreen/Container";
import LocationScreen from "../screen/LocationScreen";
//import ParentContainer from "../screen/ParentScreen/Container";

const CompanyRoute = () => {
  return (
    <Layout topMenuItems={values.topMenuItems.TOP_MENU_ROLE_COMPANY}>
      <Routes>
        <Route path="/" element={<Navigate to={"driver"} />} />
        <Route path="/service/*" element={<ServiceContainer />} />
        <Route path="/parents/*" element={<ParentContainer />} />
        <Route path="/school/*" element={<SchoolContainer />} />
        <Route path="/driver/*" element={<DriverContainer />} />
        <Route path="/dashboard/*" element={<DashboardContainer />} />
        <Route path="/absent/*" element={<AbsentContainer />} />
        <Route path="/history/*" element={<HistoryContainer />} />
        <Route path="/financial/*" element={<FinanCialScreen />} />
        <Route path='/location/*' element={<LocationScreen />} />
        <Route path="/other/*" element={<CompanyOtherContainer />} />
        <Route path="/ticket/*" element={<TicketContainer />} />

        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

export default CompanyRoute;
